import React from "react";
import { Result, Button, Row, Col, Card } from 'antd';
import * as Setting from "../utils/AuthUtils";
import { SilentSignin, isSilentSigninRequired } from "casdoor-react-sdk";

function LoginPage(props) {

  // console.warn('sono loggato o no?', Setting.isLoggedIn());

  if (isSilentSigninRequired()) {
    // if the `silentSignin` parameter exists, perform silent login processing
    return (
      <SilentSignin
        sdk={Setting.casdoorSDK}
        isLoggedIn={Setting.isLoggedIn}
        handleReceivedSilentSigninSuccessEvent={() => {
          // jump to the home page here and clear silentSignin parameter
          window.location.href = "/";
        }}
        handleReceivedSilentSigninFailureEvent={() => {
          // prompt the user to log in failed here
          alert("login failed");

        }}
      />
    );
  }

  function toLogin(event) {
    event.preventDefault();
    Setting.goToLink(Setting.getSigninUrl());
  }

  if (Setting.isLoggedIn()) {
    return (
      <Card loading={true}></Card>
    );
  } else {
    // console.warn('devo essere ridiretto qua:', Setting.getSigninUrl());
    // Setting.goToLink(Setting.getSigninUrl());
    return (
      <Row style={{ 'marginTop': '16px' }}>
        <Col span={24}>
          <Card>
            <Result
              status="error"
              title="Not authenticated!"
              subTitle="You're not authenticated!"
              extra={<Row justify="space-evenly"><Col span={4}><Button type="primary" onClick={toLogin}>Login</Button></Col><Col span={4}><Button>Go To Public Page</Button></Col></Row>}
            />
          </Card>
        </Col>
      </Row>
    );
  }
}

export default LoginPage;